import { useMemo } from "react";
import usePermissions from "hooks/usePermissions";
import usePluginEntities from "hooks/usePluginEntities";
import { DEFAULT_SECURITY_NAV_ITEM } from "components/security/bindings";
import DEFAULT_ENTERPRISE_NAV_ITEM from "components/navigation/DefaultEnterpriseNavItem";
import sortNavigationItems from "components/navigation/util/sortNavigationItems";
import mergeAndSortNavigationItems from "./util/mergeAndSortNavigationItems";
const pluginMenuItemExists = (navigationItems, description) => {
  if (!(navigationItems == null ? void 0 : navigationItems.length)) {
    return false;
  }
  return !!navigationItems.find((value) => {
    var _a;
    return ((_a = value.description) == null ? void 0 : _a.toLowerCase()) === description.toLowerCase();
  });
};
const pluginLicenseValid = (navigationItems, description) => {
  if (!(navigationItems == null ? void 0 : navigationItems.length)) return false;
  const menuItem = navigationItems.find((value) => {
    var _a;
    return ((_a = value.description) == null ? void 0 : _a.toLowerCase()) === description.toLowerCase();
  });
  return menuItem && Object.keys(menuItem).includes("useCondition") ? menuItem.useCondition() : true;
};
const useNavigationItems = () => {
  const { isPermitted } = usePermissions();
  const allNavigationItems = usePluginEntities("navigation");
  const navigationItems = useMemo(() => mergeAndSortNavigationItems(allNavigationItems), [allNavigationItems]);
  const securityLicenseInvalid = !pluginLicenseValid(navigationItems, DEFAULT_SECURITY_NAV_ITEM.description);
  return useMemo(() => {
    const enterpriseMenuIsMissing = !pluginMenuItemExists(navigationItems, DEFAULT_ENTERPRISE_NAV_ITEM.description);
    const securityMenuIsMissing = !pluginMenuItemExists(navigationItems, DEFAULT_SECURITY_NAV_ITEM.description);
    const isPermittedToEnterpriseOrSecurity = isPermitted(["licenseinfos:read"]);
    if (enterpriseMenuIsMissing && isPermittedToEnterpriseOrSecurity) {
      navigationItems.push(DEFAULT_ENTERPRISE_NAV_ITEM);
    }
    if (securityMenuIsMissing && isPermittedToEnterpriseOrSecurity || securityLicenseInvalid) {
      if (!securityMenuIsMissing) {
        navigationItems.splice(
          navigationItems.findIndex((item) => item.description === DEFAULT_SECURITY_NAV_ITEM.description),
          1
        );
      }
      navigationItems.push(DEFAULT_SECURITY_NAV_ITEM);
    }
    return sortNavigationItems(navigationItems);
  }, [navigationItems, isPermitted, securityLicenseInvalid]);
};
export default useNavigationItems;
